import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { KYMW7300Component } from './kymw7300.component';
import { DeleteCouponListService } from './api-services/delete-coupon-list.service';
import { GetCouponListService } from './api-services/get-coupon-list.service';

/**
 * 注文単位値引クーポン一覧画面 モジュール設定クラス
 *
 * @export KYMW7300Module
 * @class KYMW7300Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  declarations: [KYMW7300Component],
  providers: [DeleteCouponListService, GetCouponListService],
})
export class KYMW7300Module {}
